/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_tetradic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetradic`)
};

const es_cp_tetradic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetrádica`)
};

const de_cp_tetradic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetradisch`)
};

const nl_cp_tetradic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetradisch`)
};

const fr_cp_tetradic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tétradique`)
};

const it_cp_tetradic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetradica`)
};

const pt_br2_cp_tetradic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tétrade`)
};

const pt_cp_tetradic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetrádica`)
};

const ja_cp_tetradic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テトラード`)
};

const zh_cp_tetradic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`四分色`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_tetradic = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_tetradic(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_tetradic", locale)
	if (locale === "en") return en_cp_tetradic(inputs)
	if (locale === "es") return es_cp_tetradic(inputs)
	if (locale === "de") return de_cp_tetradic(inputs)
	if (locale === "nl") return nl_cp_tetradic(inputs)
	if (locale === "fr") return fr_cp_tetradic(inputs)
	if (locale === "it") return it_cp_tetradic(inputs)
	if (locale === "pt-BR") return pt_br2_cp_tetradic(inputs)
	if (locale === "pt") return pt_cp_tetradic(inputs)
	if (locale === "ja") return ja_cp_tetradic(inputs)
	return zh_cp_tetradic(inputs)
};